import { Fieldset } from './primitive/Fieldset';
import { Field } from './primitive/Field';
import { Checkbox } from './primitive/Checkbox';
import * as stylex from '@stylexjs/stylex';
import { FieldBuilderComponentPropsType } from '../types';
import { tinaField } from 'tinacms/react';
type CheckboxGroupProps = FieldBuilderComponentPropsType<'ConversionFormStepsFieldsCheckboxList'>;
export function CheckboxGroup({
  data,
  name
}: CheckboxGroupProps) {
  return <Field.Root name={name}>
      <Fieldset.Root render={<Checkbox.CheckboxGroup columns={data.layout === 'vertical' ? 1 : 3} />}>
        <Fieldset.Legend styles={sx.checkboxLegend} data-tina-field={tinaField(data, 'label')}>
          {data.label}
        </Fieldset.Legend>
        {data.values?.map(value => {
        if (!value) return null;
        return <Field.Item key={value.value}>
              <Field.Label>
                <Checkbox.Root name={name} value={value.value!}>
                  <Checkbox.Indicator />
                </Checkbox.Root>
                {value.value}
              </Field.Label>
            </Field.Item>;
      })}
      </Fieldset.Root>
      <Field.Error />
      <Field.Description>{data.hint}</Field.Description>
    </Field.Root>;
}
const sx = {
  checkboxLegend: {
    kWZpDQ: "xx1abn8",
    kEXP64: "xcrlgei",
    $$css: true
  }
};